/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EasyClaimCaseEventType } from './EasyClaimCaseEventType';
import {
	EasyClaimCaseEventTypeFromJSON,
	EasyClaimCaseEventTypeFromJSONTyped,
	EasyClaimCaseEventTypeToJSON,
	EasyClaimCaseEventTypeToJSONTyped,
} from './EasyClaimCaseEventType';

/**
 *
 * @export
 * @interface SaveCaseEventRequest
 */
export interface SaveCaseEventRequest {
	/**
	 *
	 * @type {string}
	 * @memberof SaveCaseEventRequest
	 */
	caseId?: string | null;
	/**
	 *
	 * @type {EasyClaimCaseEventType}
	 * @memberof SaveCaseEventRequest
	 */
	eventType?: EasyClaimCaseEventType;
	/**
	 *
	 * @type {string}
	 * @memberof SaveCaseEventRequest
	 */
	additionalData?: string | null;
}

/**
 * Check if a given object implements the SaveCaseEventRequest interface.
 */
export function instanceOfSaveCaseEventRequest(value: object): value is SaveCaseEventRequest {
	return true;
}

export function SaveCaseEventRequestFromJSON(json: any): SaveCaseEventRequest {
	return SaveCaseEventRequestFromJSONTyped(json, false);
}

export function SaveCaseEventRequestFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): SaveCaseEventRequest {
	if (json == null) {
		return json;
	}
	return {
		caseId: json['caseId'] == null ? undefined : json['caseId'],
		eventType:
			json['eventType'] == null ? undefined : EasyClaimCaseEventTypeFromJSON(json['eventType']),
		additionalData: json['additionalData'] == null ? undefined : json['additionalData'],
	};
}

export function SaveCaseEventRequestToJSON(json: any): SaveCaseEventRequest {
	return SaveCaseEventRequestToJSONTyped(json, false);
}

export function SaveCaseEventRequestToJSONTyped(
	value?: SaveCaseEventRequest | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		caseId: value['caseId'],
		eventType: EasyClaimCaseEventTypeToJSON(value['eventType']),
		additionalData: value['additionalData'],
	};
}
